import { invalidate } from '@react-three/fiber';
import { useEffect } from 'react';

import { ArticleTransformationMesh } from 'app/modules/wallforming/components/scenes/objects/articles/ArticleTransformationMesh';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const ArticlePivotControls = () => {
    const arePivotControlsActive = usePlacementStore((state) => state.arePivotControlsActive);

    useEffect(() => {
        invalidate();
    }, [arePivotControlsActive]);

    return arePivotControlsActive && <ArticleTransformationMesh />;
};
